export default "__VITE_ASSET__f6f4dc50__"